import React from 'react';
import { Col, Layout, Row } from 'antd';
import { Content } from 'antd/es/layout/layout';

import logoDark from '@Images/logo-dark.png';

import {
  Approvals,
  Greeting,
  // Instagram,
  LatestUpdates,
  LeaveBalance,
  // MyTeam,
  // ProfileHealth,
  Reports,
  // TimeCheck,
  TodaySummary,
} from '@Features/DashboardWidgets';

import styles from './dashboard.module.css';

interface DashboardDesktopProps {
  children: JSX.Element;
}

const DashboardLogo: React.FC = () => {
  return (
    <div className={styles.logo}>
      <img
        className={styles.image}
        src={logoDark}
        alt="Trojan construction company logotype"
      />
    </div>
  );
};

const DashboardDesktop: React.FC<DashboardDesktopProps> = ({ children }) => {
  return (
    <Layout>
      {React.cloneElement(children, {
        logoComponent: <DashboardLogo />,
      })}
      <Content className={styles.container}>
        <Greeting />
        <div className={styles.content}>
          <Row className={styles.row} gutter={24}>
            <Col span={8}>
              <TodaySummary />
            </Col>
            <Col span={8}>
              <Approvals />
            </Col>
            {/* Should be replaced after integration all parts of widget */}
            <Col span={8}>
              <LeaveBalance />
            </Col>
            {/* end */}
            {/* <Col span={8}>
              <MyTeam />
            </Col> */}
          </Row>
          <Row className={styles.row} gutter={24}>
            <Col span={12}>
              <Reports />
            </Col>
            <Col span={12}>
              <LatestUpdates />
            </Col>
          </Row>
          {/* <Row className={styles.row} gutter={24}>
            <Col span={8}>
              <LeaveBalance />
            </Col>
            <Col span={8}>
              <ProfileHealth />
            </Col>
            <Col span={8}>
              <TimeCheck />
            </Col>
          </Row> */}
          {/* <Row className={styles.row} gutter={24}>
            <Col span={16}>
              <LatestUpdates />
            </Col>
            <Col span={8}>
              <Instagram />
            </Col>
          </Row> */}
        </div>
      </Content>
    </Layout>
  );
};

export default DashboardDesktop;
